import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import delayP from 'delay'

import { setWalletConnectURI, setIsconnectedWithWallet } from '../../../redux/walletConnect/action'

import { FootRow, GoCreate } from './UnlockFromKeystore'
import { Consumer as BNCClientConsumer } from '../../../containers/context/BNCClientProvider'
import { Consumer as WalletConnectConsumer } from '../../../containers/context/WalletConnectProvider'

import errorIcon from '../../../static/images/error-icon.svg'
import qrCodeSvg from '../../../static/images/unlock/qrcode.svg'
import qrCodeHoverSvg from '../../../static/images/unlock/qrcode_hover.svg'
import { withI18n } from '../../../i18n/util'
import { NETWORK_ENV } from '../../../utils/httpRequest'
import { setFingerPrint } from '../../../utils/fingerPrint'

const Wrapper = styled.div`
  width: 100%;
  color: #48515d;
  position: relative;
  padding-bottom: 40px;
`

export const Title = styled.div`
  font-size: 14px;
  padding: 10px 0;
  color: #48515d;
  padding-top: 50px;
  font-weight: 400;
  position: relative;
  p {
    margin-bottom: 5px;
  }
  .recommend {
    font-size: 16px;
    font-weight: bold;
    height: 20px;
    line-height: 21px;
    margin-bottom: 6px;
  }
  .text {
    font-size: 16px;
    line-height: 24px;
    font-weight: normal;
    span {
      font-weight: 600;
    }
  }
  .text-note {
    font-size: 12px;
    line-height: 18px;
    position: absolute;
    bottom: -30px;
    padding-left: 18px;
    .i {
      border: 1px solid #48515d;
      width: 10px;
      height: 10px;
      margin-top: 3px;
      position: absolute;
      left: 0;
      &:after {
        background: #48515d;
        height: 3px;
      }
      &:before {
        background: #48515d;
      }
    }
    a {
      color: #f0b90b;
    }
  }
  .show {
    font-size: 18px;
    &:hover {
      color: inherit;
    }
  }
  .notes {
    font-size: 12px;
    line-height: 16px;
    padding: 5px;
    color: #f0b90b;
    margin: 1rem 0;
    background: rgba(239, 184, 11, 0.15);
    border-radius: 2px;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .i {
    display: flex;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    border: 2px solid rgba(240, 185, 11, 1);
    background: transparent;
    margin-right: 5px;
    flex-direction: column;
    align-items: center;
    &:before {
      content: ' ';
      display: block;
      height: 2px;
      width: 2px;
      background: #f0b90b;
      margin-top: 2px;
      margin-bottom: 2px;
    }
    &:after {
      content: ' ';
      display: block;
      height: 5px;
      width: 2px;
      background: #f0b90b;
    }
  }
`

const ShowWalletConnectQRButton = styled.button`
  width: 402px;
  height: 96px;
  line-height: 96px;
  background: linear-gradient(270deg, rgba(246, 247, 248, 0.3) 0%, rgba(234, 236, 239, 0.3) 100%);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.09);
  font-size: 16px;
  color: #48515d;
  cursor: pointer;
  border-radius: 3px;
  position: relative;
  justify-content: flex-start;
  text-indent: 30px;
  margin-top: 36px;
  margin-bottom: 12px;
  font-weight: 600;
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  .qrcode_svg {
    display: block;
  }
  .qrcode_hover_svg {
    display: none;
  }
  &:hover {
    background: linear-gradient(90deg, rgba(251, 218, 60, 1) 0%, rgba(239, 184, 11, 1) 100%);
    color: #fff;
    .qrcode_svg {
      display: none;
    }
    .qrcode_hover_svg {
      display: block;
    }
  }
  span {
    font-size: 14px;
  }
  img {
    width: 56px;
    margin-left: 40px;
    @media (min-width: 320px) and (max-width: 623px) {
      margin-left: 30px;
    }
  }
  i {
    margin-right: 10px;
  }
  input {
    width: 100%;
    height: 100%;
    opacity: 0;
    display: block;
    top: 0;
    left: 0;
    position: absolute;
    cursor: pointer;
  }

  @media (min-width: 320px) and (max-width: 623px) {
    width: 100%;
  }
`

const DownloadTips = styled.div`
  color: #959eb1;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  margin-bottom: 40px;
  a {
    color: inherit;
  }
`

const ErrorMsg = styled.div`
  color: #f23051;
  position: absolute;
  bottom: 45px;
  left: 0;
  right: 0;
  font-size: 14px;
  display: flex;
  height: 20px;
  img {
    width: 15px;
    margin-right: 5px;
  }
`

class UnlockWalletConnect extends PureComponent {
  static propTypes = {
    unlock: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired, // from `withRouter`
    dispatch: PropTypes.func.isRequired, // from `withRouter`
    formatI18nText: PropTypes.func.isRequired,
    deviceInfo: PropTypes.object,
  }

  static defaultProps = {
    deviceInfo: {},
  }

  constructor(props) {
    super(props)
    this.state = {
      errMsg: '',
    }
    this._onConnect = this._onConnect.bind(this)
    this._onDisconnect = this._onDisconnect.bind(this)
  }

  _unlock = walletConnectClient => async ev => {
    const { dispatch } = this.props
    ev.preventDefault()
    if (walletConnectClient.connected()) {
      walletConnectClient.disconnect()
      await delayP(1000) // to be safe because we cannot await on disconnect
    }
    const uri = await walletConnectClient.startSession(false)
    console.log('WalletConnect URI', uri)
    dispatch(setWalletConnectURI(uri))
    walletConnectClient.on('connect', this._onConnect)
    walletConnectClient.on('disconnect', this._onDisconnect)
  }

  _onConnect = ({ accounts, chainId }) => {
    const { unlock, dispatch, deviceInfo } = this.props
    console.log(
      `UnlockWalletConnect: session update received. chainId: ${chainId}, accounts: ${accounts.join(
        ','
      )}`
    )
    // TODO: accounts select
    dispatch(setWalletConnectURI(''))
    dispatch(setIsconnectedWithWallet(true))
    unlock('HARDWARE', accounts[0], '', '', { isHardware: true, isWalletConnect: true })
    setFingerPrint(deviceInfo, 'unlock_walletconnect', accounts[0], '')
  }

  _onDisconnect = params => {
    const { dispatch } = this.props
    dispatch(setWalletConnectURI(''))
    console.log(params)
  }

  _gotoCreate = ev => {
    ev.preventDefault()
    const { history } = this.props
    history.push('/create')
  }

  render() {
    const { errMsg } = this.state
    const { formatI18nText } = this.props

    return (
      <WalletConnectConsumer>
        {walletConnectClient => (
          <BNCClientConsumer>
            {bncClient => (
              <Wrapper>
                <Title>
                  <p className="recommend">{formatI18nText('unlock.walletConnet.title')}</p>
                  {NETWORK_ENV === 'testnet' && (
                    <p className="notes">
                      <i className="i" />
                      {formatI18nText('unlock.walletConnect.notes')}
                    </p>
                  )}
                  <p className="text">{formatI18nText('unlock.walletConnet.showWalletQrCode')}</p>
                  {NETWORK_ENV !== 'testnet' && (
                    <p className="text-note">
                      <i className="i" />
                      {formatI18nText('unlock.walletConnect.recommendedWallet')}:{' '}
                      <span>
                        <a href="https://trustwallet.com/">Trust Wallet</a>{' '}
                      </span>
                      <span>
                        , <a href="https://safepal.io/">SafePal</a>{' '}
                      </span>
                      <span>
                        , <a href="https://www.coolwallet.io/">CoolWallet S</a>
                      </span>
                      <span>
                        , <a href="https://www.mathwallet.org/en/">Math Wallet</a>
                      </span>
                      <span>
                        , <a href="https://meet.one/">Meet.one</a>
                      </span>
                      <span>
                        ,{' '}
                        <a href="https://chrome.google.com/webstore/detail/equal-wallet-the-metamask/blnieiiffboillknjnepogjhkgnoapac?hl=en">
                          Equal
                        </a>
                      </span>
                      <span>
                        , <a href="https://atomicwallet.io/">Atomic Wallet</a>
                      </span>
                    </p>
                  )}
                </Title>
                <ShowWalletConnectQRButton
                  onClick={this._unlock(walletConnectClient, bncClient)}
                  id="Unlock_Wallet_Connect"
                >
                  <span>{formatI18nText('unlock.walletConnet.qrCodeDesc1')}</span>
                  <img src={qrCodeSvg} className="qrcode_svg" alt="" />
                  <img src={qrCodeHoverSvg} className="qrcode_hover_svg" alt="" />
                </ShowWalletConnectQRButton>
                <DownloadTips>
                  {formatI18nText('unlock.walletConnet.qrCodeDesc2')}{' '}
                  <a href="https://trustwallet.com">
                    {formatI18nText('unlock.walletConnet.getTrustWallet')}
                  </a>
                  {' >>'}
                </DownloadTips>
                <FootRow>
                  <GoCreate className="goCreate create-link" onClick={this._gotoCreate}>
                    <span>{formatI18nText('unlock.createNewWallet')}</span>
                  </GoCreate>
                </FootRow>
                {errMsg && (
                  <ErrorMsg>
                    <img src={errorIcon} alt="" />
                    <span>{errMsg}</span>
                  </ErrorMsg>
                )}
              </Wrapper>
            )}
          </BNCClientConsumer>
        )}
      </WalletConnectConsumer>
    )
  }
}

export default withI18n(withRouter(UnlockWalletConnect))
